import { render, staticRenderFns } from "./BookingsView.vue?vue&type=template&id=65192203&scoped=true"
import script from "./BookingsView.vue?vue&type=script&lang=ts"
export * from "./BookingsView.vue?vue&type=script&lang=ts"
import style0 from "./BookingsView.vue?vue&type=style&index=0&id=65192203&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65192203",
  null
  
)

export default component.exports